<table>
    <tr *ngFor="let event of events">
        <td>{{event.log}}</td>
    </tr>
</table>
